import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dep0105CtlrOut } from 'app/core/models/api/dep/dep0105'
import { selectDep0105 } from 'app/core/services/prd/dep.service'
import { RootState } from 'app/core/store'
/**
 * 이어가기 Store
 */

const slice = createSlice({
    name: 'continuable',
    initialState: {} as Dep0105CtlrOut,
    reducers: {
        clearContinuable: () => ({} as Dep0105CtlrOut),
    },
    extraReducers: (builder) => {
        builder.addMatcher(selectDep0105.matchFulfilled, (_, action) => {
            return { ...action.payload }
        })
    },
})

export const { clearContinuable } = slice.actions
export const selectorContinuable = (state: RootState) => {
    return state.continuable
}
export default slice.reducer
